export default {
  name: "BlackSelect",
  props: {
    value: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: "请选择"
    },
    options: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      model: this.value
    };
  }
};